<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const props = defineProps<{ center: [number, number]; zoom?: number }>();

const { mapbox: mapboxAllowed } = useCookieConsent();
</script>

<template>
  <AppMapBrowseButton v-bind="{ ...props, ...$attrs }" :mapbox-allowed="mapboxAllowed" />
</template>
